<template>
  <section>
    <div class="sidebar-container" :class="{ isCollapse: isCollapse }">
      <sidebar :collapse="isCollapse" />
      <el-button class="sidebar-elapse-btn" :icon="isCollapse ? 'el-icon-arrow-right' : 'el-icon-arrow-left'" circle
        size="mini" @click="toggleCollapse"></el-button>
    </div>
    <router-view v-if="allow && permit" :class="{ isCollapse: isCollapse }" class="view-container" :key="$route.path" />
    <div v-else-if="!permit" class="view-container">
      <el-col :sm="{ span: 16, offset: 4 }" :lg="{ span: 12, offset: 6 }">
        <el-card class="service-prompt" shadow="never">
          <div slot="header" class="clearfix">
            <span>{{ $t("common.prompt") }}</span>
          </div>
          {{ $t("common.noPermit") }}
        </el-card>
      </el-col>
    </div>
    <div v-else-if="!allow" class="view-container">
      <el-col :sm="{ span: 16, offset: 4 }" :lg="{ span: 12, offset: 6 }">
        <el-card class="service-prompt" shadow="never">
          <div slot="header" class="clearfix">
            <span>{{ $t("common.prompt") }}</span>
            <el-button style="float: right; padding: 3px 0" type="text" @click="clickOK">{{ $t("common.ok")
              }}</el-button>
          </div>
          {{ $t("order.noValidService") }}
        </el-card>
      </el-col>
    </div>
  </section>
</template>

<script>
import Cookies from 'js-cookie';
import { Sidebar } from "../components";
import { MenuList } from "@/router/menu";
export default {
  components: {
    Sidebar,
  },
  data() {
    return {
      isCollapse: false,
      allow: this.$store.getters.allowService,
      permit: this.$store.getters.permitMenu,
    };
  },
  created() {
    this.isCollapse = Cookies.get('menu-collapse') === 'true';

    let m = MenuList[this.$route.meta["key"]];
    if (!m || !m.i18n) {
      return;
    }
    document.title = 'F&Plus - ' + this.$t(m.i18n);
  },
  methods: {
    clickOK() {
      this.$router.push("/my/order").catch(() => { });
    },
    toggleCollapse() {
      this.isCollapse = !this.isCollapse;
      Cookies.set('menu-collapse', this.isCollapse);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";

.view-container {
  margin-left: $sideBarWidth + 20px !important;
  margin-right: 20px;
  margin-top: 10px;
  margin-bottom: 10px;
}

.view-container.isCollapse {
  margin-left: $sideBarisCollapseWidth + 20px !important;
}

.service-prompt {
  margin-top: 20vh;
}

.sidebar-container {
  transition: width 0.28s;
  width: $sideBarWidth;
  background-color: #eaecef;
  height: 100%;
  z-index: 1001;
  position: absolute;

  ::v-deep .el-scrollbar {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;

    .el-scrollbar__wrap {
      overflow-x: hidden !important;
      padding: 10px 0;
    }
  }

  ::v-deep .el-menu {
    border: none;
  }

  .sidebar-elapse-btn {
    position: absolute;
    top: 10px;
    right: -14px;
    z-index: 1;
  }
}

.sidebar-container.isCollapse {
  width: $sideBarisCollapseWidth;
}
</style>